import db from '../../plugins/firebase'
import { collection, query, getDocs, addDoc, updateDoc, doc, where } from "firebase/firestore"

const filterAllBoletos = async (filter) => {
  const boletosRef = collection(db, "boletos");
  const params = []
  let boletoList = []

  params.push(where("active", "==", true))

  if(filter && !filter.isPago)
    params.push(where("isPago", '==', filter.isPago))

  if(filter && filter.idObra)
    params.push(where("obra.id", '==', filter.idObra))
  
  //boletosRef.orderByValue("data_vencimento_timestamp");

  const q = query(boletosRef, ...params);

  try {
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      boletoList.push({
        id: doc.id,
        ...doc.data()
      })
    });
  } catch (error) {
    //console.error("Error fetching data:", error);
  }

  if(filter && filter.dataInicio && filter.dataInicio != NaN)
    boletoList = boletoList.filter((item)=> filter.dataInicio <= item.data_vencimento_timestamp )

  if(filter && filter.dataFim && filter.dataFim != NaN)
    boletoList = boletoList.filter((item)=> filter.dataFim >= item.data_vencimento_timestamp )
  
  return boletoList
}

const getAllBoletos = async ()=>{
  const querySnap = await getDocs(query(collection(db, 'boletos')));
  const boletoList = []
  querySnap.forEach((doc) => {
    boletoList.push({ id: doc.id, ...doc.data() })
  })
  return boletoList;
}

const deleteBoleto = async (payload) => {
  const colRef = await doc(db, 'boletos', payload.id);
  await updateDoc(colRef, {
    ...payload,
    active: false
  });
}

const saveBoleto = async (payload) => {
  const colRef = collection(db, 'boletos')
  await addDoc(colRef, payload)
}

const updateBoleto = async (payload) => {
  const colRef = await doc(db, 'boletos', payload.id);
  await updateDoc(colRef, payload);
}

export { filterAllBoletos, getAllBoletos, saveBoleto, updateBoleto, deleteBoleto }
